export const GET_OFFER_LIST = null;
export const CREATE_OFFER = null;
export const GET_OFFER_BY_ID = null;
export const SELECTED_OFFER_ID = null;
export const EDIT_OFFER = null;
export const DELETE_OFFER_BY_ID = null;
export const SELECTED_OFFERS_AND_PACKAGES_SPONSORSHIP_DETAILS = null;
